// src/pages/admin/DashboardAdmin.jsx
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import workflowApi from '../../api/workflowApi';

const DashboardAdmin = () => {
  const { user } = useSelector(state => state.auth);
  const navigate = useNavigate();

  const [procesos, setProcesos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtros, setFiltros] = useState({
    estado: 'todos',
    pagina: 1,
    tamano: 20
  });
  const [estadisticas, setEstadisticas] = useState({
    total: 0,
    pendientesRegistro: 0,
    pendientesDocumentos: 0,
    enRevision: 0,
    completados: 0
  });

  useEffect(() => {
    cargarProcesos();
  }, [filtros]);

  const cargarProcesos = async () => {
    setLoading(true);
    try {
      // TODO: Implementar API real
      // const response = await workflowApi.obtenerDashboardAdmin(filtros);
      
      // Mock data por ahora
      const mockProcesos = [
        {
          workflowNegocioId: 1,
          entidadId: 1,
          nombreEntidad: 'Municipio de Floridablanca',
          estadoWorkflow: 7, // Pendiente documentos
          nombreEstado: 'Pendiente Documentos',
          colorEstado: '#f39c12',
          fechaCreacion: '2025-08-20T11:45:13',
          fechaUltimaActividad: '2025-08-22T10:30:00',
          usuarioCreador: 'Sistema',
          requiereIntervencion: true,
          documentosPendientes: 3,
          documentosEnRevision: 2,
          documentosAprobados: 3
        },
        {
          workflowNegocioId: 2,
          entidadId: 2,
          nombreEntidad: 'Alcaldía de Bucaramanga',
          estadoWorkflow: 9, // En revisión admin
          nombreEstado: 'En Revisión Admin',
          colorEstado: '#9b59b6',
          fechaCreacion: '2025-08-21T14:20:10',
          fechaUltimaActividad: '2025-08-22T09:15:00',
          usuarioCreador: 'admin@redeprog.com',
          requiereIntervencion: true,
          documentosPendientes: 0,
          documentosEnRevision: 5,
          documentosAprobados: 3
        }
      ];

      setProcesos(mockProcesos);
      
      // Calcular estadísticas
      const stats = mockProcesos.reduce((acc, proceso) => {
        acc.total++;
        if (proceso.estadoWorkflow === 2) acc.pendientesRegistro++;
        if (proceso.estadoWorkflow === 7) acc.pendientesDocumentos++;
        if (proceso.estadoWorkflow === 9) acc.enRevision++;
        if (proceso.estadoWorkflow === 5) acc.completados++;
        return acc;
      }, { total: 0, pendientesRegistro: 0, pendientesDocumentos: 0, enRevision: 0, completados: 0 });

      setEstadisticas(stats);

    } catch (error) {
      console.error('Error cargando procesos:', error);
    } finally {
      setLoading(false);
    }
  };

  const procesosFiltrados = procesos.filter(proceso => {
    if (filtros.estado === 'todos') return true;
    if (filtros.estado === 'requieren_atencion') return proceso.requiereIntervencion;
    if (filtros.estado === 'en_revision') return proceso.estadoWorkflow === 9;
    if (filtros.estado === 'completados') return proceso.estadoWorkflow === 5;
    return true;
  });

  const formatearFecha = (fecha) => {
    return new Date(fecha).toLocaleDateString('es-CO', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const obtenerPrioridad = (proceso) => {
    const diasSinActividad = Math.floor(
      (new Date() - new Date(proceso.fechaUltimaActividad)) / (1000 * 60 * 60 * 24)
    );
    
    if (diasSinActividad > 5) return 'alta';
    if (diasSinActividad > 2) return 'media';
    return 'baja';
  };

  const colorPrioridad = {
    alta: 'bg-red-100 text-red-800',
    media: 'bg-yellow-100 text-yellow-800',
    baja: 'bg-green-100 text-green-800'
  };

  return (
    <div className="min-h-screen bg-gray-50 py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Dashboard de Administración
              </h1>
              <p className="text-gray-600 mt-1">
                Gestión y revisión de procesos de inscripción | {user?.nombre || user?.email}
              </p>
            </div>
            <div className="flex space-x-3">
              <button
                onClick={() => window.location.reload()}
                className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg font-medium"
              >
                Actualizar
              </button>
            </div>
          </div>
        </div>

        {/* Estadísticas */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-6">
          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-blue-500">
            <div className="flex items-center">
              <div className="text-3xl font-bold text-blue-600">{estadisticas.total}</div>
              <div className="ml-3">
                <div className="text-sm font-medium text-gray-900">Total</div>
                <div className="text-xs text-gray-600">Procesos activos</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-orange-500">
            <div className="flex items-center">
              <div className="text-3xl font-bold text-orange-600">{estadisticas.pendientesRegistro}</div>
              <div className="ml-3">
                <div className="text-sm font-medium text-gray-900">Registro</div>
                <div className="text-xs text-gray-600">Pendientes</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-yellow-500">
            <div className="flex items-center">
              <div className="text-3xl font-bold text-yellow-600">{estadisticas.pendientesDocumentos}</div>
              <div className="ml-3">
                <div className="text-sm font-medium text-gray-900">Documentos</div>
                <div className="text-xs text-gray-600">Pendientes</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-purple-500">
            <div className="flex items-center">
              <div className="text-3xl font-bold text-purple-600">{estadisticas.enRevision}</div>
              <div className="ml-3">
                <div className="text-sm font-medium text-gray-900">En Revisión</div>
                <div className="text-xs text-gray-600">Requieren atención</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6 border-l-4 border-green-500">
            <div className="flex items-center">
              <div className="text-3xl font-bold text-green-600">{estadisticas.completados}</div>
              <div className="ml-3">
                <div className="text-sm font-medium text-gray-900">Completados</div>
                <div className="text-xs text-gray-600">Finalizados</div>
              </div>
            </div>
          </div>
        </div>

        {/* Filtros */}
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setFiltros(prev => ({ ...prev, estado: 'todos' }))}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filtros.estado === 'todos'
                  ? 'bg-blue-100 text-blue-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Todos ({estadisticas.total})
            </button>
            <button
              onClick={() => setFiltros(prev => ({ ...prev, estado: 'requieren_atencion' }))}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filtros.estado === 'requieren_atencion'
                  ? 'bg-red-100 text-red-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Requieren Atención ({estadisticas.enRevision + estadisticas.pendientesDocumentos})
            </button>
            <button
              onClick={() => setFiltros(prev => ({ ...prev, estado: 'en_revision' }))}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filtros.estado === 'en_revision'
                  ? 'bg-purple-100 text-purple-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              En Revisión ({estadisticas.enRevision})
            </button>
            <button
              onClick={() => setFiltros(prev => ({ ...prev, estado: 'completados' }))}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                filtros.estado === 'completados'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Completados ({estadisticas.completados})
            </button>
          </div>
        </div>

        {/* Lista de Procesos */}
        <div className="bg-white rounded-lg shadow-sm">
          <div className="p-6 border-b border-gray-200">
            <h2 className="text-lg font-semibold text-gray-900">
              Procesos de Inscripción
            </h2>
          </div>

          {loading ? (
            <div className="p-8 text-center">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Cargando procesos...</p>
            </div>
          ) : procesosFiltrados.length === 0 ? (
            <div className="p-8 text-center">
              <div className="text-gray-400 text-6xl mb-4">📋</div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                No hay procesos para mostrar
              </h3>
              <p className="text-gray-600">
                No se encontraron procesos con los filtros seleccionados
              </p>
            </div>
          ) : (
            <div className="divide-y divide-gray-200">
              {procesosFiltrados.map((proceso) => {
                const prioridad = obtenerPrioridad(proceso);
                
                return (
                  <div key={proceso.workflowNegocioId} className="p-6 hover:bg-gray-50">
                    <div className="flex items-center justify-between">
                      <div className="flex-1">
                        <div className="flex items-center space-x-3 mb-2">
                          <h3 className="text-lg font-medium text-gray-900">
                            {proceso.nombreEntidad}
                          </h3>
                          <span 
                            className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                            style={{ 
                              backgroundColor: proceso.colorEstado + '20', 
                              color: proceso.colorEstado 
                            }}
                          >
                            {proceso.nombreEstado}
                          </span>
                          <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorPrioridad[prioridad]}`}>
                            {prioridad === 'alta' && '🔴'} 
                            {prioridad === 'media' && '🟡'} 
                            {prioridad === 'baja' && '🟢'} 
                            {prioridad.toUpperCase()}
                          </span>
                        </div>
                        
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600 mb-3">
                          <div>
                            <span className="font-medium">ID:</span> {proceso.entidadId}
                          </div>
                          <div>
                            <span className="font-medium">Creado:</span> {formatearFecha(proceso.fechaCreacion)}
                          </div>
                          <div>
                            <span className="font-medium">Última actividad:</span> {formatearFecha(proceso.fechaUltimaActividad)}
                          </div>
                          <div>
                            <span className="font-medium">Usuario:</span> {proceso.usuarioCreador}
                          </div>
                        </div>

                        {/* Estado de documentos */}
                        <div className="flex space-x-4 text-sm">
                          {proceso.documentosPendientes > 0 && (
                            <span className="text-orange-600">
                              📄 {proceso.documentosPendientes} pendientes
                            </span>
                          )}
                          {proceso.documentosEnRevision > 0 && (
                            <span className="text-purple-600">
                              👀 {proceso.documentosEnRevision} en revisión
                            </span>
                          )}
                          {proceso.documentosAprobados > 0 && (
                            <span className="text-green-600">
                              ✅ {proceso.documentosAprobados} aprobados
                            </span>
                          )}
                        </div>
                      </div>

                      <div className="flex space-x-2 ml-4">
                        <button
                          onClick={() => navigate(`/inscripcion/${proceso.entidadId}`)}
                          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-medium"
                        >
                          Ver Proceso
                        </button>
                        
                        {proceso.requiereIntervencion && (
                          <button
                            onClick={() => navigate(`/inscripcion/${proceso.entidadId}/revision`)}
                            className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm font-medium"
                          >
                            Revisar
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Alerta si requiere intervención */}
                    {proceso.requiereIntervencion && (
                      <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <div className="flex items-center">
                          <span className="text-yellow-500 mr-2">⚠️</span>
                          <span className="text-sm text-yellow-800 font-medium">
                            Este proceso requiere intervención administrativa
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* Acciones rápidas */}
        <div className="bg-white rounded-lg shadow-sm p-6 mt-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            Acciones Rápidas
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <button
              onClick={() => {
                // TODO: Implementar exportación
                alert('Funcionalidad en desarrollo');
              }}
              className="p-4 border-2 border-dashed border-blue-300 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors"
            >
              <div className="text-blue-600 text-xl mb-2">📊</div>
              <div className="font-medium text-blue-900">Exportar Reporte</div>
              <div className="text-sm text-blue-700">Descargar estadísticas</div>
            </button>

            <button
              onClick={() => {
                // TODO: Implementar notificaciones masivas
                alert('Funcionalidad en desarrollo');
              }}
              className="p-4 border-2 border-dashed border-green-300 rounded-lg hover:border-green-400 hover:bg-green-50 transition-colors"
            >
              <div className="text-green-600 text-xl mb-2">📧</div>
              <div className="font-medium text-green-900">Notificaciones</div>
              <div className="text-sm text-green-700">Enviar recordatorios</div>
            </button>

            <button
              onClick={() => {
                // TODO: Implementar configuración
                alert('Funcionalidad en desarrollo');
              }}
              className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-gray-400 hover:bg-gray-50 transition-colors"
            >
              <div className="text-gray-600 text-xl mb-2">⚙️</div>
              <div className="font-medium text-gray-900">Configuración</div>
              <div className="text-sm text-gray-700">Ajustar parámetros</div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAdmin;